import { gql } from '@apollo/client'

export const Login = gql`
    mutation Login($input: LoginInput!) {
        login(input: $input) {
            token
            roles
        }
    }
`

export const ForgotPassword = gql`
    mutation ForgotPassword($email: String!) {
        forgotPassword(email: $email) {
            success
        }
    }
`

export const ResetPassword = gql`
    mutation ResetPassword($token: String!, $newPassword: String!) {
        resetPassword(token: $token, newPassword: $newPassword) {
            token
        }
    }
`

export const ResendConfirmationEmail = gql`
    mutation ResendConfirmationEmail($input: ResendConfirmationEmailInput!) {
        resendConfirmationEmail(input: $input) {
            success
        }
    }
`

export const Register = gql`
    mutation Register($input: RegisterInput!) {
        register(input: $input) {
            success
        }
    }
`
